module.exports = __webpack_public_path__ + "static/c5dc1a6bc8a39e535ce4a7793fa807c6bd9fff204c740aa2ea8bd126eec84529-cec55619d1395c0e683bc4d49291ffeb.png";